import api from "../../services/api";
import { types } from "../types/types";
import Constants from "../../services/constants";
import { hideLoaderAction, showLoaderAction } from "./loaderAction";
import { showToast } from "./toastAction";

const getShippingOrder = (setLoading, status = "PLACED") => async (dispatch) => {
    try {
        if (setLoading) {
            setLoading(true);
        }
 
        const query = `?status=${encodeURIComponent(status)}`;
        const res = await api("get", `${Constants.END_POINT.SHIPPING_ORDER}${query}`);
 
        if (res?.success && res?.data) {
            const orders = Array.isArray(res.data) ? res.data : res.data.orders;
            const payload = Array.isArray(orders) ? orders : [];

            dispatch({
                type: types.CHANGE_SHIPPING_ORDERS,
                payload,
            });
        } else {
            // API call failed or returned no data
            dispatch({
                type: types.CHANGE_SHIPPING_ORDERS,
                payload: [],
            });
        }
    } catch (error) {
        console.error("Error fetching shipping orders:", error);
        dispatch({
            type: types.CHANGE_SHIPPING_ORDERS,
            payload: [],
        });
    } finally {
        if (setLoading) {
            setLoading(false);
        }
    }
};
const viewShippingOrder = (id, returnData) => async (dispatch) => {
    dispatch(showLoaderAction());
    const res = await api("get", Constants.END_POINT.SHIPPING_ORDER + id);
    if (res.success) {
        if (res.data) {
            if (returnData) {
                returnData(res.data);
            }
        }
    }
    dispatch(hideLoaderAction());
};
 
const updateOrderStatus = (id, status, extraData = {}, onSuccess) => async (dispatch) => {
    dispatch(showLoaderAction());
    const res = await api("put", Constants.END_POINT.SHIPPING_ORDER + id, { status, ...extraData });
    if (res.success) {
        dispatch(showToast({ severity: "success", summary: res.message }));
        if (onSuccess) {
            onSuccess();
        }
    } else {
        dispatch(showToast({ severity: "error", summary: res.message }));
    }
    dispatch(hideLoaderAction());
};
 
export { getShippingOrder, viewShippingOrder, updateOrderStatus };
 
